import { render } from "./ProfitLossWidget.vue?vue&type=template&id=8a1cf9a0"
import script from "./ProfitLossWidget.vue?vue&type=script&lang=js"
export * from "./ProfitLossWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__